module.exports = __webpack_public_path__ + "static/media/big-closed-icon.870e281c.png";